export const storeStickers = [
  {
    id: 1,
    title: "great job",
    img: "greatJob.png",
    price: 50,
    company: "cute neko",
    info:
      "You can purchase this cute sticker and send it to your friends to show your love for them and boost their motivation [Single Use]",
    inCart: false,
    count: 0,
    total: 0,
    popular: true
  },
  {
    id: 2,
    title: "fighting",
    img: "fighting.png",
    price: 50,
    company: "cute neko",
    info:
      "You can purchase this cute sticker and send it to your friends to show your love for them and boost their motivation [Single Use]",
    inCart: false,
    count: 0,
    total: 0,
    popular: true
  },
  {
    id: 3,
    title: "awesome",
    img: "awesome.png",
    price: 50,
    company: "cute neko",
    info:
      "You can purchase this cute sticker and send it to your friends to show your love for them and boost their motivation [Single Use]",
    inCart: false,
    count: 0,
    total: 0,
    popular: false
  },
  {
    id: 4,
    title: "go get'em",
    img: "goGetEm.png",
    price: 50,
    company: "cute neko",
    info:
      "You can purchase this cute sticker and send it to your friends to show your love for them and boost their motivation [Single Use]",
    inCart: false,
    count: 0,
    total: 0,
    popular: false
  }
];


export const detailSticker = {
    id: 1,
    title: "smiley face",
    img: "smileyFace.png",
    price: 50,
    company: "cute neko",
    info:
      "You can purchase this cute sticker and send it to your friends to show your love for them and boost their motivation [Single Use]",
    inCart: false,
    count: 0,
    total: 0,
    popular: true
};

export const user_point = 1000;

export const threshold = 30;
